import { action } from '@/lib/api';

const setWorkflowActiveInputState = (payload) => {
  action('SET_WORKFLOW_ACTIVE_INPUT_STATE', payload);
};

export default setWorkflowActiveInputState;
